<div class="root">
    <div class="logo"></div>
    <span>
        <h2>NLR Plan</h2>
    </span>
    <div class="spacer"></div>
    <span class="utilities">
        <div [hidden]="!enableHomeItem">
            <a routerLink="/redirect-home">
                <i class="nlrp-icon nlrp-icon-home"></i>
            </a>
        </div>
        <div
            [hidden]="!enableHomeItem || enableHomeItem && this.enableHeaderItems"
            class="pagePipe"></div>
        <div
            [hidden]="!enableHeaderItems"
            class="pagePipe"></div>
        <div [hidden]="!enableHeaderItems">
            <a
                routerLink="/plan-dashboard"
                [title]="mydashboardTitle">
                <i class="nlrp-icon nlrp-icon-dashboard-plans"></i>
            </a>
        </div>
        <div
            [hidden]="!enableHeaderItems"
            class="pagePipe"></div>
        <div [hidden]="!enableHeaderItems">
            <a
                [title]="actionItemsTitle"
                (click)="toggleHamburgerVisibility()">
                <i class="nlrp-icon nlrp-icon-open-close-side-menu"></i>
            </a>
        </div>
        <div
            [hidden]="!enableHeaderItems"
            class="pagePipe"></div>
        @if (hasDesignPreferencesPermissions()) {
            <a (click)="showUserPreferences()"><i class="nlrp-icon nlrp-icon-settings"></i></a>
        }
        @if (hasDesignPreferencesPermissions()) {
            <div class="pagePipe"></div>
        }
        <a
            ><i class="nlrp-icon nlrp-icon-user"></i> <span>{{getUserDisplayName()}}</span></a
        >
        <div class="pagePipe"></div>
        <a
            (click)="logout()"
            data-test-automation="logout">
            <i class="nlrp-icon nlrp-icon-logout"></i>
            <span class="logout">Logout</span>
        </a>
    </span>
</div>
